import KeyFlowVO from 'commons/vo/KeyFlowVO';

type CodeVOProps = {
  ID: number;
  PID: number;
  NAME: string;
  CODEVALUE: string;
  CREATEDATE: string;
  CREATEUSER: string;
  MODIFYDATE: string;
  SEQ: number;
};

class CodeVO extends KeyFlowVO {
  id: number;
  pid: number;
  name: string;
  codevalue: string;
  createDate: string;
  createUser: string;
  modifyDate: string;
  seq: number;

  constructor(data: CodeVOProps) {
    super(data);
    this.id = data.ID;
    this.pid = data.PID;
    this.name = data.NAME;
    this.codevalue = data.CODEVALUE;
    this.createDate = data.CREATEDATE;
    this.createUser = data.CREATEUSER;
    this.modifyDate = data.MODIFYDATE;
    this.seq = data.SEQ;
  }
}

export default CodeVO;
